import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import { useChipiContext } from "../context";
import type { TransferHookInput } from "@chipi-stack/types";

type TransferInput = { params: TransferHookInput; bearerToken: string };

/**
 * Hook for transferring tokens
 */
export function useTransfer(): {
  transfer: (input: TransferInput) => void;
  transferAsync: (input: TransferInput) => Promise<string>;
  data: string | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  isSuccess: boolean;
  reset: () => void;
} {
  const { chipiSDK } = useChipiContext();

  const mutation: UseMutationResult<string, Error, TransferInput> = useMutation(
    {
      mutationFn: (input: TransferInput) =>
        chipiSDK.transfer({
          params: {
            ...input.params,
            amount: String(input.params.amount),
          },
          bearerToken: input.bearerToken,
        }),
    }
  );

  return {
    transfer: mutation.mutate,
    transferAsync: mutation.mutateAsync,
    data: mutation.data,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    isSuccess: mutation.isSuccess,
    reset: mutation.reset,
  };
}
